import { ref } from 'vue'
import getSensorData from '../../../../composables/getSensorData'

const processMultipleSessionData = () => {
  const data = ref(new Map())
  const shouldRenderCharts = ref(false)
  const timeDataFetched = ref(new Map()) // Now tracking fetched time data per session
  const timeData = ref(new Map())
  const colors = ['#4CAF50', '#F86624', '#00B1F2']
  const chartColors = ref(new Map())

  const { fetchTimeDataOffsets, fetchDataForChart } = getSensorData()

  const clearSessionData = () => {
    chartColors.value.clear()
    data.value.clear()
    timeDataFetched.value.clear()
  }

  const renderSensorDataByType = async (sessionIds, userDevices, sensorType) => {
    // Ensure data is fetched for all sessions
    for (const sessionId of sessionIds) {
      if (!timeDataFetched.value.has(sessionId)) {
        timeData.value.set(sessionId, await fetchTimeDataOffsets(sessionId))
        timeDataFetched.value.set(sessionId, true)
      }
    }

    if (sensorType.includes('Group') || sensorType.includes('Sensors')) {
      return // Skip Group and Sensors types
    }

    const aggregatedData = {
      left: [],
      right: []
    }

    const sessionColors = {
      left: [],
      right: []
    }

    // Fetch and aggregate data for each session
    for (let i = 0; i < sessionIds.length; i++) {
      const sessionId = sessionIds[i]
      const res = await fetchDataForChart(sessionId, sensorType, userDevices, timeData.value.get(sessionId))
      if (res.length) {
        // Group data by 'left' and 'right'
        for (const item of res) {
          if (item.name && item.name.toLowerCase() === 'left') {
            item.name = sessionId
            aggregatedData.left.push(item)
            sessionColors.left.push(colors[i])
          } else if (item.name && item.name.toLowerCase() === 'right') {
            item.name = sessionId
            aggregatedData.right.push(item)
            sessionColors.right.push(colors[i])
          }
        }
      }
    }
    // Set the aggregated data for chart rendering
    if (aggregatedData.left.length > 0) {
      data.value.set(`left-${sensorType.toLowerCase()}`, aggregatedData.left)
      chartColors.value.set(`left-${sensorType.toLowerCase()}`, sessionColors.left)
    }
    if (aggregatedData.right.length > 0) {
      data.value.set(`right-${sensorType.toLowerCase()}`, aggregatedData.right)
      chartColors.value.set(`right-${sensorType.toLowerCase()}`, sessionColors.right)
    }

    shouldRenderCharts.value = true
  }

  return {
    data,
    shouldRenderCharts,
    clearSessionData,
    renderSensorDataByType,
    chartColors
  }
}

export default processMultipleSessionData
